import * as React from "react"
import {Grid} from "@mui/material";

import RepricingCrudFormTitleRow from "../TitleRow";
import RepricingFormRuleValue from "./RuleValue";
import RepricingFormSetUpSelect from "./SetUp";


export default function RepricingCrudFormSetUpRow() {
	return <>
		<Grid item xs={12}>
			<RepricingCrudFormTitleRow
				icon="gear"
				title="Trigger"
				subtitle="Activate action if price gap with competitor hits specified threshold."
			/>
		</Grid>

		<Grid item xs={2}>
			<RepricingFormSetUpSelect />
		</Grid>

		<Grid item xs={1}>
			<RepricingFormRuleValue />
		</Grid>
	</>
}